import React from 'react';

export const LazyApplication = React.lazy(() => import('./application'))
